import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables, theme } from '@styles';

/**
 * Publish component styles
 * @returns {Function}
 */

export const useStyles = makeStyles(() =>
  createStyles({
    publish: {
      // background: variables.color.primary.white,
      display: 'flex',
      flex: '1 1 auto',
      flexDirection: 'column',
      height: '100%',
    },

    publishButton: {
      minWidth: '3.8rem',
      padding: '.8rem .8rem',
      '& svg path': {
        fill: variables.colorV2.button.contained.primary.icon.fill.default,
      },

      '&:hover': {
        '& svg path': {
          fill: variables.colorV2.button.contained.primary.icon.fill.hover,
        },
      },

      '&:active': {
        '& svg path': {
          fill: variables.colorV2.button.contained.primary.icon.fill.active,
        },
      },

      '&:disabled': {
        background: 'none',
        border: `0 solid ${variables.color.primary.lightGrayDarker}`,
        color: variables.colorV2.button.disabled.text.default,

        '& svg path': {
          fill: variables.colorV2.button.disabled.icon.default,
        },
      },
    },

    topInfo: {
      padding: '0 0 1.6rem 0',
    },

    header: {
      // display: 'flex',
      alignItems: 'center',
      flex: '0 0 auto',
      justifyContent: 'space-between',
      padding: '0 1.6rem 2rem 1.6rem',
      // borderBottom: `${variables.borderWidth.sm} solid ${variables.color.primary.lightGray}`,
    },

    title: {
      '&&': {
        color: variables.colorV2.text.header,
        fontSize: '2rem',
        fontWeight: 400,
        lineHeight: '2.5rem',
      },
    },

    panelBox: {
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '0 1 auto',
      overflowY: 'hidden',
      padding: '2rem 1.6rem',
    },

    panelBoxContent: {
      height: '100%',
      overflowY: 'auto',
    },

    headerRight: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'self-end',
    },

    column: {
      display: 'flex',
      flexDirection: 'column',
    },

    row: {
      display: 'flex',
      alignItems: 'center',
    },

    spaceBetween: {
      justifyContent: 'space-between',
    },

    rowDirectionColumn: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },

    grid: {
      padding: '0 0 1.6rem 0',
    },

    gridLeft: {
      paddingLeft: theme.spacing(1),
    },

    gridCenter: {
      // padding: theme.spacing(0, 1),
    },

    label: {
      padding: theme.spacing(1, 0),
      color: variables.colorV2.text.default,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    value: {
      '&$value': {
        padding: '0 0 1rem 0',
        color: variables.colorV2.text.default,
        fontWeight: 600,
        // whiteSpace: 'nowrap',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
      },
    },

    valueWithAction: {
      '&&': {
        padding: '0 0 0 0',
      },
    },

    gridRight: {
      textAlign: 'right',
    },

    panelTitleHeading: {
      marginBottom: '0.4rem',
    },

    downloadPublishContainer: {
      alignItems: 'self-end',
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
    },

    buttonContainer: {
      padding: '1.6rem 1.6rem 0 1.6rem',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },

    changeSubscribersButton: {
      alignSelf: 'flex-start',
      padding: '0 0 0 0',
    },

    addAction: {
      color: variables.colorV2.link.text.default,
      textDecoration: 'underline',
      fontSize: '1.2rem',
      fontWeight: 400,
      // padding: '0 0 1rem 0',
      minWidth: 'unset',

      '&:hover': {
        backgroundColor: 'transparent',
        color: variables.colorV2.link.text.hover,
      },

      '&:disabled': {
        opacity: 1,
      },
    },

    change: {
      color: variables.colorV2.link.text.default,
      textDecoration: 'underline',
      fontSize: '1.2rem',
      fontWeight: 400,
      // padding: '0 0 1rem 0',
      minWidth: 'unset',

      '&:hover': {
        backgroundColor: 'transparent',
        color: variables.colorV2.link.text.hover,
      },

      '&:disabled': {
        opacity: 1,
      },
    },

    checkBtn: {
      minWidth: 'unset',
      transition: 'opacity 0.25s',
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      borderRadius: variables.borderRadius.sm,
      border: `${variables.borderWidth.sm} solid ${variables.color.primary.lightGrayDarker}`,

      '&:hover': {
        backgroundColor: 'transparent',
        opacity: '0.6',
      },
    },

    mailSelect: {
      maxWidth: '40rem',
      display: 'flex',
    },

    info: {
      color: variables.color.semantic.highlight,
    },

    warnings: {
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      // paddingBottom: theme.spacing(2),
      paddingTop: '1.6rem',
    },

    warning: {
      display: 'flex',

      '& svg': {
        marginRight: theme.spacing(0.5),
      },
    },

    alert: {
      margin: theme.spacing(2),
    },

    changeLink: {
      padding: theme.spacing(0, 0, 0.25),
      margin: 0,
      fontSize: variables.font.size.md,
      fontWeight: variables.font.weight.medium,
      lineHeight: variables.lineHeight.lg,
      whiteSpace: 'pre-wrap',
      color: variables.color.primary.mainPurple,
      textTransform: 'none',
      transition: 'all 0.3s',

      '&:hover': {
        backgroundColor: 'transparent',
        opacity: variables.opacity.high,
      },
    },

    downloadButton: {
      border: `0 solid ${variables.color.primary.lightGrayDarker}`,
      minWidth: '3.8rem',
      padding: theme.spacing(1, 1),
      width: '3.8rem',

      '&:hover': {
        border: `0 solid ${variables.color.primary.mainPurple}`,
      },
      '&:hover svg path': {
        fill: variables.colorV2.button.contained.primary.icon.fill.hover,
      },
    },
  }),
);
